import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FaqsComposition } from '@shared/compositions';
import { DialogRef } from '@ngneat/dialog';
import { isMobileView } from '@core/utils';
import { NgxBottomSheetService } from 'ngx-bottom-sheet';
import { Logger } from '@core/services';
import { ButtonComponent, DropdownComponent, IconComponent, ImageSelectorComponent } from '@shared/components/ui';
import { FormErrorComponent } from '@shared/components';
import { untilDestroyed } from '@ngneat/until-destroy';
import { SectionType } from '@core/enums';

const log = new Logger('Faq Form Component');

@Component({
  selector: 'app-faq-form',
  imports: [CommonModule, IconComponent, ButtonComponent, ImageSelectorComponent, NgSelectModule, ReactiveFormsModule, TranslateModule, DropdownComponent, FormErrorComponent],
  templateUrl: './faq-form.component.html',
  styleUrls: ['./faq-form.component.scss'],
})
export class FaqFormComponent extends FaqsComposition implements OnInit {
  bottomSheetService: NgxBottomSheetService;
  protected readonly isMobileView = isMobileView;
  protected readonly SectionType = SectionType;
  private readonly _dialogRef: DialogRef;

  constructor() {
    super();
    if (!isMobileView()) {
      this._dialogRef = inject(DialogRef);
      this.currentFaq = this._dialogRef.data?.faq;
    } else {
      this.bottomSheetService = inject(NgxBottomSheetService);
      this.currentFaq = this.bottomSheetService.currentSheetData?.faq;
    }
  }

  get isUpdateMode(): boolean {
    return !!(this.currentFaq && this.currentFaq?.id && this.currentFaq?.image);
  }

  get faqId(): number {
    return this.currentFaq?.id || null;
  }

  ngOnInit() {
    this._initFaqForm();
    this._fetchAllFaqsCategories();

    if (isMobileView()) {
      if (this.bottomSheetService.currentSheetData && this.bottomSheetService.currentSheetData.categories && this.bottomSheetService.currentSheetData.categories.length > 0) {
        this.categories = this.bottomSheetService.currentSheetData.categories;
      } else {
        this._fetchAllFaqsCategories();
      }
    } else {
      if (this._dialogRef.data && this._dialogRef.data.categories && this._dialogRef.data.categories.length > 0) {
        this.categories = this._dialogRef.data.categories;
      } else {
        this._fetchAllFaqsCategories();
      }
    }

    if (this.currentFaq) {
      this._fetchFaqById(this.currentFaq.id)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (faq) => {
            this.currentFaq = faq;

            this.form.patchValue({
              title: this.currentFaq.title,
              description: this.currentFaq.description,
              category: this.currentFaq.category,
              position: this.currentFaq.position,
              image: this.currentFaq.imageUrl,
            });
          },
        });
    }
  }

  save(btnRef?: ButtonComponent) {
    if (this.form.invalid) {
      this.markAllInvalidControlsAndScrollToFirst(this.form);
      log.error('Form is invalid.');
      return;
    }
    this.saveFaq(this.form.value, btnRef);
  }

  close(): void {
    if (!isMobileView()) {
      this._dialogRef.close();
    } else {
      this._bottomSheetService.close();
    }
  }
}
